.filesTooltipContainer {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 6px;
}

.tooltipText {
  font-size: 12px;
}

.fileItem {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;

  p {
    font-size: 14px;
    text-align: center;
    line-height: 16px;
  }

  &__iconButton {
    cursor: pointer;

    svg {
      scale: 0.8;
      fill: #ea1b0a;
    }
  }
}